import { Component } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Provider, useDispatch, useSelector, connect } from 'react-redux';
import store from './store/store';
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AdminLayout from './AdminLayout';
import AdminHome from './screens/AdminHome';
import DriverHome from './screens/DriverHome';
import NoPage from './NoPage';
import Login from './screens/Login';
import NotLoggedIn from './NotLoggedIn';

import './App.css';
import { DataContainer } from './components/DataContainer';
import { default as AdminQueryView } from './screens/admin/QueryView';
import { default as AdminAnsweredQueryView } from './screens/admin/AnsweredQueryView';
import { default as AdminAcceptedQueryView } from './screens/admin/AcceptedQueryView';
import { default as AdminJobView } from './screens/admin/JobView';
import { default as DriverQueryView } from './screens/driver/QueryView';
import { default as DriverAnsweredQueryView } from './screens/driver/AnsweredQueryView';
import { default as DriverAcceptedQueryView } from './screens/driver/AcceptedQueryView';
import { default as DriverJobView } from './screens/driver/JobView';
import { default as AdminSchedule } from './screens/admin/Schedule';
import { default as DriverSchedule } from './screens/driver/Schedule';
import { default as DriverReports } from './screens/admin/DriverReports';
import Resources from './screens/Resources';
import Archive from './screens/Archive';
import Arrangements from './screens/Arrangements';
import CreateArrangement from './screens/CreateArrangement';
import DriverLayout from './DriverLayout';
import Inquery from './Inquery';
import Arrangement from './screens/Arrangement';
import Feedback from './screens/Feedback';
import CreateUser from './screens/CreateUser';
import CreateBus from './screens/CreateBus';
import AddFoodPackage from './screens/AddFoodPackage';

import loadingScreenBg from './res/avalehe-pilt.png';
import AcceptResponse from './AcceptResponse';
import RejectResponse from './RejectResponse';
import {default as DriverFeedback} from './Feedback';
import EmailDriverConfirmJob from './EmailDriverConfirmJob';




const Protected = ({ roles }) => {
  const isLoading = useSelector((state) => state.loading["user/fetchUser"]);
  const authenticated = useSelector((state) => state.user.authenticated);

  if(isLoading) {
    return (
      <DataContainer actionType={'user/fetchUser'}>
        <div style={{ width: '100%', height: '100vh' }}>
          <img src={loadingScreenBg} style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
      </DataContainer>
    );
  }

  return authenticated ? <Outlet/> : <Navigate to="/login"/>;
};

const Switch = (props) => {
  const isLoading = useSelector((state) => state.loading["user/fetchUser"]);
  const authenticated = useSelector((state) => state.user.authenticated);
  const user = useSelector((state) => state.user.data);

  if(isLoading) {
    return (
      <DataContainer actionType={'user/fetchUser'}>
        <div style={{ width: '100%', height: '100vh' }}>
          <img src={loadingScreenBg} style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
      </DataContainer>
    );
  }

  if(user && "role" in user) for(const key in props) {
    if(key == user["role"]) return props[key];
  }

  return <Navigate to="/login"/>;
}

class App extends Component {
  componentDidMount() {
    console.log("starting ...");
  }

  render() {
    return (
      <>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <BrowserRouter basename={'/portal'}>
          <Routes>
            <Route path="/">
              <Route index element={<Navigate to="/login" />}/>
              <Route path="login" element={<Login />} />
              <Route path="inquery" element={<Inquery />} />
              <Route path="accept" element={<AcceptResponse />} />
              <Route path="confirm" element={<AcceptResponse />} />
              <Route path="reject" element={<RejectResponse />} />
              <Route path="confirmJob" element={<EmailDriverConfirmJob />} />
              <Route path="feedback" element={<DriverFeedback />} />

              <Route element={<Protected />}>
                <Route path="platform" element={<Switch 
                    admin={<AdminLayout/>}
                    driver={<DriverLayout/>} />}>

                  <Route index element={<Switch 
                    admin={<AdminHome/>}
                    driver={<DriverHome/>} />}/>

                  <Route path="query/:id" element={<Switch 
                    admin={<AdminQueryView/>}
                    driver={<DriverQueryView/>} />} />

                  <Route path="confirmedQuery/:id" element={<Switch 
                    admin={<AdminAcceptedQueryView/>}
                    driver={<DriverAcceptedQueryView/>} />} />

                  <Route path="answeredQuery/:id" element={<Switch 
                    admin={<AdminAnsweredQueryView/>}
                    driver={<DriverAnsweredQueryView/>} />} />

                  <Route path="job/:id" element={<Switch 
                    admin={<AdminJobView/>}
                    driver={<DriverJobView/>} />} />

                  <Route path="schedule" element={<Switch 
                    admin={<AdminSchedule/>}
                    driver={<DriverSchedule/>} />} />

                  <Route path="resources" element={<Switch 
                    admin={<Resources/>} />} />

                  <Route path="archive" element={<Switch 
                    admin={<Archive/>} />} />

                  <Route path="feedback" element={<Switch 
                    admin={<Feedback/>} />} />

                  <Route path="arrangements" element={<Switch 
                    admin={<Arrangements/>} />} />

                  <Route path="arrangement/:id" element={<Switch 
                    admin={<Arrangement/>} />} />

                  <Route path="arrangements/new" element={<Switch 
                    admin={<CreateArrangement/>} />} />

                  <Route path="createUser" element={<Switch 
                    admin={<CreateUser/>} />} />

                  <Route path="createBus" element={<Switch 
                    admin={<CreateBus/>} />} />

                  <Route path="addFoodPackage" element={<Switch
                    admin={<AddFoodPackage/>} />} />

                  <Route path="driverReports" element={<Switch
                    admin={<DriverReports/>} />} />

                  <Route path="*" element={<NoPage/>} />

                </Route>
              </Route>

              <Route path="*" element={<NoPage/>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authenticated: state.authenticated
});

export default connect(mapStateToProps)(App);
